import { ModuleWithProviders, NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StatusCodeService } from "@obg/ngx.core";
import { CookieService, LocationService, ReferrerService } from "@obg/ngx.global";
import { LoggingService } from "@obg/ngx.global.evo";

import { ServerCacheControlEffect } from "./cache-control/cache-control.effect";
import { ServerCookieService } from "./cookie/server-cookie.service";
import { ServerLocationService } from "./location/location.service";
import { UniversalLoggingService } from "./logging/universal-logging.service";
import { ServerReferrerService } from "./referrer/referrer.service";
import { ServerStatusCodeService } from "./status-code/status-code.service";

@NgModule({
	imports: [EffectsModule.forFeature([ServerCacheControlEffect])],
})
export class UniversalExpressModule {
	static forRoot(): ModuleWithProviders<UniversalExpressModule> {
		return {
			ngModule: UniversalExpressModule,
			providers: [
				{ provide: CookieService, useClass: ServerCookieService },
				{ provide: LoggingService, useClass: UniversalLoggingService },
				{ provide: LocationService, useClass: ServerLocationService },
				{ provide: StatusCodeService, useClass: ServerStatusCodeService },
				{ provide: ReferrerService, useClass: ServerReferrerService },
			],
		};
	}
}
